import { faIcon } from "@utils/faIcon"
import isModKeyPressed from "@utils/isModKeyPressed"

import { Skeleton } from "@particles/index"

import EmptyState from "@molecules/EmptyState/EmptyState"

import { Settings } from "@templates/index"

import { SETTINGS_ROUTES } from "@routes/settings"

import styles from "./SettingsCatalogs.module.scss"
import { useCatalogsQuery } from "./SettingsCatalogs.store"
import CatalogCard from "./components/CatalogCard/CatalogCard"

function SettingsCatalogsContent() {
    const catalogsQuery = useCatalogsQuery()

    const renderCatalogCards = () => {
        if (catalogsQuery.isLoading) {
            return (
                <div className={styles.skeleton}>
                    <Skeleton height={88} />
                </div>
            )
        }

        if (catalogsQuery.isError) {
            return (
                <div className={styles.emptyStateContainer}>
                    <EmptyState
                        variant="error"
                        icon={faIcon({ name: "circle-xmark", style: "solid" })}
                        title="Hmm, something went wrong..."
                        supportText="An error occurred while fetching your catalogs."
                        primaryCTA={{ children: "Try again", onClick: () => void catalogsQuery.refetch() }}
                    />
                </div>
            )
        }

        const catalogs = catalogsQuery.data ?? []

        if (catalogs.length === 0) {
            return (
                <div className={styles.emptyStateContainer}>
                    <EmptyState
                        variant="default"
                        title="No catalogs yet"
                        supportText="Connect a supplier's e-commerce store and its catalog will appear here."
                        primaryCTA={{
                            children: "Go to E-Commerce settings",
                            onClick: (event) => {
                                if (isModKeyPressed(event)) {
                                    window.open(SETTINGS_ROUTES.ecommerce, "_blank", "noopener,noreferrer")
                                } else {
                                    window.location.assign(SETTINGS_ROUTES.ecommerce)
                                }
                            },
                        }}
                    />
                </div>
            )
        }

        return catalogs.map((catalog) => <CatalogCard key={catalog.id} catalog={catalog} />)
    }

    return (
        <Settings.PageContainer>
            <Settings.PageHeader
                variant="page-heading"
                title="Catalogs"
                subtitle="Browse your connected stores' catalogs and subscribe to the brands, categories, and items you want in your pricebook."
            />

            <Settings.Divider />

            <Settings.Section>{renderCatalogCards()}</Settings.Section>
        </Settings.PageContainer>
    )
}

export default function SettingsCatalogs() {
    return (
        <Settings.Wrapper title="Catalogs">
            <SettingsCatalogsContent />
        </Settings.Wrapper>
    )
}
